import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "contentment"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  class: "ratio"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "ratio"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "ratio"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = {
  class: "ratio"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'StarLevelCount',
  props: {
    evaluationInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  setup(__props) {
    let props = __props;
    let info = ref();
    watch(props.evaluationInfo, newValue => {
      info.value = newValue || {};
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CardHeader, {
        title: "满意度调查"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/icon_star.png')
      }, null, 8, ["src"]), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "title"
      }, "饭菜质量", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(info).foodQualitySatisfaction) + "%", 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/icon_star.png')
      }, null, 8, ["src"]), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "title"
      }, "食品卫生", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(info).foodHygieneSatisfaction) + "%", 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/icon_star.png')
      }, null, 8, ["src"]), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "title"
      }, "服务态度", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(info).serviceAttitudeSatisfaction) + "%", 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/icon_star.png')
      }, null, 8, ["src"]), _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "title"
      }, "就餐环境", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(info).diningEnvironmentSatisfaction) + "%", 1)])])]);
    };
  }
};